export default __webpack_public_path__ + "static/media/Tasset of the Bloodhunter.a6eea6ca.jpg";